import type { ReactElement } from 'react';

import React from 'react';
import tw from 'twin.macro';
import Head from 'next/head';
import { AnimatePresence } from 'framer-motion';

import AppLayout from '@/providers/AppLayout';
import WithNftSaleMachine from '@/features/pwNftSale/components/WithNftSaleMachine';
import Species from '@/pages/rarities/index/Species';
import TopInfo from '@/pages/rarities/index/TopInfo';

export default function RarityListLandingPage() {
  return (
    <>
      <Head>
        <title>All Rarities | PhalaWorld</title>
      </Head>
      <main tw="relative">
        <AnimatePresence mode="wait">
          <WithNftSaleMachine>
            <div tw="h-screen bg-black text-white flex flex-col gap-10 pt-28">
              <TopInfo />
              <Species />
            </div>
          </WithNftSaleMachine>
        </AnimatePresence>
      </main>
    </>
  );
}

RarityListLandingPage.getLayout = (page: ReactElement) => {
  return <AppLayout>{page}</AppLayout>;
};
